<template>
  <div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div>
      <div class="hxq_ppsp">
        <div class="hxq_fllb_sx">
          <div class="hxq_fllb_sx_yx">
            <!-- <a href="javascript: void(0);" data-sx="close">收起筛选</a>
            <a href="/News/xwzx.html"
                style="display: inline-block;width: 175px;margin-right: 30px;background: none;border:none;text-align:left;">常见问题，产品知识：相关文章</a> -->
            <div class="hxq_yzjk_mbx">
              <a href="/" class="allResult">首页<span class="newspan">></span></a>
              <div class="hxq_fllb_ysz" @mouseenter="isOrNo('one')" @mouseleave="leave">
                <em :class="{myborder:isShow=='one'}">
                  <i>{{ level1name || '全部' }}</i><img src="../../assets/images/xjt.png" :class="{on:isShow=='one'}">
                </em>
                <div class="hxq_fllb_ysz_yj" :style="isShow === 'one'?'max-height: 300px;':'max-height:0;'">
                  <div style="border:1px solid #ddd;padding:10px">
                  <router-link :to="{path:'/Classify',query:{ grand_id:item.id }}" v-for="(item,index) in cateGroyMsg.message" :key="index">{{ item.title }}</router-link>
                  </div>
                </div>
              </div>
              <span class="newspan">></span>
              <div class="hxq_fllb_ysz" @mouseenter="isOrNo('two')" @mouseleave="leave">
                <em :class="{myborder:isShow=='two'}"><i>{{ level2name || '全部' }}</i><img src="../../assets/images/xjt.png" :class="{on:isShow=='two'}"></em>
                <div class="hxq_fllb_ysz_yj" :style="isShow === 'two'?'max-height: 300px;':'max-height:0;'">
                  <div style="border:1px solid #ddd;padding:10px">
                  <router-link :to="{path:'/Classify',query:{ parent_id:item.id }}" v-for="(item,index) in cateGroyMsg.children" :key="index">{{ item.title }}</router-link>
                  </div>
                </div>
              </div>
              <span class="newspan" v-if="cateGroyMsg.threeChildren">></span>
              <div class="hxq_fllb_ysz" v-if="cateGroyMsg.threeChildren" @mouseenter="isOrNo('three')" @mouseleave="leave">
                <em :class="{myborder:isShow=='three'}"><i>{{ level3name || '全部' }}</i><img src="../../assets/images/xjt.png" :class="{on:isShow=='three'}"></em>
                <div class="hxq_fllb_ysz_yj" :style="isShow === 'three'?'max-height: 300px;':'max-height:0;'">
                  <div style="border:1px solid #ddd;padding:10px">
                  <router-link :to="{path:'/Goods',query:{ cid:item.id }}" v-for="(item,index) in cateGroyMsg.threeChildren" :key="index">{{ item.title }}</router-link>
                  </div>
                </div>
              </div>
              <span class="newspan" v-if="cateGroyMsg.group_list && cateGroyMsg.group_list.length > 1">></span>
              <div class="hxq_fllb_ysz" v-if="cateGroyMsg.group_list  && cateGroyMsg.group_list.length > 1" @mouseenter="isOrNo('four')" @mouseleave="leave">
                <em :class="{myborder:isShow=='four'}"><i>{{ level4name || '全部' }}</i><img src="../../assets/images/xjt.png" :class="{on:isShow=='four'}"></em>
                <div class="hxq_fllb_ysz_yj" :style="isShow === 'four'?'max-height: 300px;':'max-height:0;'">
                  <div style="border:1px solid #ddd;padding:10px">
                    <span style="padding:5px" @click="checkParam(item)" v-for="(item,index) in cateGroyMsg.group_list" :key="index">{{ item.name }}</span>
                  </div>
                </div>
              </div>
              <span class="newspan" v-if="listQuery.cgid">></span>
              <div style="display: inline-block;" v-if="listQuery.cgid">{{ fourtitle }}</div>
            </div>
            <div class="clearfix">
              <el-tag
                v-for="(item,index) in selectName" :key="index"
                closable
                :disable-transitions="false"
                type="danger"
                @close="handleClose(index)">
                {{item.param_name}}: {{item.name}}
              </el-tag>
            </div>
          </div>
          <div class="hxq_fllb_sx_tj" :style="AttrStyle" v-loading="atterloading" v-show="true">
            <div class="hxq_fllb_sx_tj1" v-if="brandList.length && !brandType">
              <em>品牌：</em>
              <div>
                <a href="javascript:void(0);" class="on">全部</a>
                <template v-for="(item,index) in brandList">
                  <a href="javascript:void(0);" :key="index" @click="checkBrand(index)">{{ item.name }}</a>
                </template>
              </div>
              <!-- <span>更多</span> -->
            </div>
            <template v-for="(item,index) in Attribute.slice(0,u)">
              <div class="hxq_fllb_sx_tj1" :key="index" v-if="!item.isSelect" :style="item.open?'max-height:200px;overflow-y: auto;':'height:34px;overflow: hidden;'">
                <em>{{ item.name }}：</em>
                <div :ref="'he'+index">
                  <a href="javascript:;" class="on">全部</a>
                  <a href="javascript:;" v-for="(value,i) in item.option_values" :key="i" @click="checkAttribute(i,index)">{{ value.name }}</a>
                </div>
                <span v-show="item.showMore" @click="changeOpen(index)" :data="getHeight(('he'+index), index)">{{item.open?'收起':'展开'}}</span>
              </div>
            </template>
            <div v-if="Attribute.length > 4" class="showMoreAttr" @click="changeAttrOpen()">
              <span v-if="AttrOpen" class="showmore-text">收起<i class='up-arrow'></i></span>
              <span v-else class="showmore-text">更多参数（{{ Attribute[4].name }}<span v-if="Attribute[5]">/{{ Attribute[5].name }}...</span>）<i></i></span>
            </div>
          </div>
        </div>
        <div class="hxq_yzjk_px">
          <!-- <div class="hxq_yzjk_px_lt">
            <a href="javascript:;" style="width: 149px;" paixu="">综合排序</a>
            <a href="javascript:;" style="width: 149px;" pricepx="" paixu="pricepx">价格
            ↑↓
            </a>
            <a  href="javascript:;" style="width: 149px;" xlpx="" paixu="xlpx">销量
            ↓
            </a>
          </div> -->
          <div class="hxq_yzjk_right1">
            <div class="hxq_yzjk_right1_one">
              <span class="pricelass" :class="{on:myprice}" style="width:100px" v-if="current_user && current_user.id && current_user.company_id != 1"><a href="javascript:;"  @click="screen()">协议产品</a></span>
              <span class="bigtut" :class="{on:listMode=='card'}"><a href="javascript:;" @click="listMode='card'">大图</a></span>
              <span class="smalltut" :class="{on:listMode=='list'}"><a href="javascript:;"  @click="listMode='list'">列表</a></span>
            </div>
            <div class="hxq_yzjk_right1_two">
              共 <em class="red">{{ total }}</em> 件商品
              <!-- <em class="red">345435</em> / 56456 -->
            </div>
            <a class="hxq_yzjk_right1_four " href="javascript:;" @click="batchAddCart()">
              加入购物车
            </a>
          </div>
        </div>
        <div class="hxq_ppsp_box" v-if="listMode=='card'" v-loading="qyloading">
          <ul class="hxq_ppsp_ul clearfix">
            <li v-for="(item,index) in list" :key="index" class="this_page_css" style="position:relative;">
              <img class="agreement" src="../../assets/images/xy11.png" v-if="item.pid && current_user.id && current_user.company_id != 1">
              <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title">
                <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" onerror="../../assets/images/zwtp.jpg" :alt="item.title" width="220" height="220">
                <!-- <el-image
                  :src="item.imgpath"
                  fit="fill"
                  style="width:220px;height:220px"
                  >
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/zwtp.jpg" width="220" height="220"/>
                  </div>
                </el-image> -->
              </router-link>
              <h3>
                <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" class="this_page_title" target="_blank" :title="item.title">{{ item.title }}</router-link>
              </h3>
              <div class="hxq_ppsp_ul_jg">
                <em style="font-size:0;">
                  <span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">￥</span>
                  <span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">{{ item.tax_price }}</span>
                  <span v-else style="font-weight:bold">询价</span>
                  <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-if="item.delivery_time">
                    {{ item.delivery_time }}日出货
                  </i>
                  <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-else>
                    当日出货
                  </i>
                </em>
              </div>
              <div class="hxq_ppsp_ul_join clearfix">
                <div class="hxq_ppsp_ul_join_l" style="height: 40px;">
                  <p v-if="item.plant_sku && current_user.id">物料代码：{{ item.plant_sku }}</p>
                  <p v-else>志鹏货号：{{ item.sku }}</p>
                  <p>销量：<count-to :start-val="0" :end-val="parseInt(item.sales)" :duration="2600" class="card-panel-num"/></p>
                  <!--<p>库存：<if condition="$vo['number'] gt 0">{$vo['number']}<else/>0</if>销量：{$vo['salescount'] | default='0'}</p>-->
                </div>
              </div>
              <div class="hxq_ppsp_ul_join clearfix">
                <div class="hs-collect" style="height: 32px;line-height: 32px;">
                  <el-button v-if="item.isCollect" type="warning" :autofocus="true" size="small" icon="el-icon-star-on" style="float:left;" @click="collect(item)">已收藏</el-button>
                  <el-button v-else type="warning" :autofocus="true" size="small" icon="el-icon-star-off" style="float:left;" @click="collect(item)">收藏</el-button>
                  <el-button type="primary" plain size="small" icon="el-icon-shopping-cart-full" style="float:right;" @click="addCart(item)">加入购物车</el-button>
                </div>
              </div>
              <!-- <div class="hxq_ppsp_ul_join clearfix">
                <div style="height: 33px;"></div>
              </div> -->
            </li>
          </ul>
          <div class="cght_cnxhtiwtjsp" v-if="emptyShow && list.length==0">
            <div>
              <em class="myemptydata">暂无数据</em>
            </div>
          </div>
        </div>
        <div class="hxq_ppsp_box" v-if="listMode=='list'">
          <div class="fllbsmall_con">
            <div class="fllbsmall_con_tit clearfix">
              <div style="width: 294px;"><span>商品信息</span></div>
              <div style="width: 133px;">品牌</div>
              <div style="width: 342px;">规格</div>
              <div style="width: 139px;">志鹏价</div>
              <div class="w140">预计出货日</div>
              <div class="w145" style="width: 150px;">购买数量</div>
            </div>
            <div class="fllbsmall_con_bottom">
              <ul>
                <li class="clearfix this_page_li"  v-for="(item,index) in list" :key="index">
                  <div class="fllbsmall_con_bottom_1 clearfix" style="width: 294px;">
                    <router-link class="fllbsmall_con_bottom_1l" :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title">
                      <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" width="76" height="76">
                    </router-link>
                    <div class="fllbsmall_con_bottom_1r" :class="{'agreement_list':item.pid && current_user.id && current_user.company_id != 1}">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title">{{ item.title }}</router-link></h3>
                      <span v-if="item.plant_sku && current_user.id">物料代码：{{ item.plant_sku }}</span>
                      <span v-else>志鹏货号：{{ item.sku }}</span>
                    </div>
                  </div>
                  <div class="m33" style="width: 133px;">{{item.brand_title}}</div>
                  <div style="width: 342px;text-align:left;height:80px">
                    <el-tag size="mini" style="margin-left:10px;margin-top:6px;" v-for="(sp,index) in item.specParamList" :key="index">{{sp.param_name}}：{{sp.option_value}}</el-tag>
                  </div>
                  <div class="m33 red" style="width: 139px;font-weight:bold;" v-if="item.tax_price && item.tax_price > 0">￥{{ item.tax_price}}</div>
                  <div class="m33 red" style="width: 139px;font-weight:bold;" v-else>询价</div>
                  <!--<div class="w133 red m33">￥{$vo.marketprice}</div>-->
                  <div class="w140 list_surekc" style="margin-top:18px;">
                    <em v-if="item.delivery_time">
                      <span>{{ item.delivery_time }}日出货</span>
                    </em>
                    <em v-else>
                      <em>有库存</em>
                      <span>当日出货</span>
                    </em>
                  </div>
                  <div class="list_sureinput" style="margin-top:16px;width:130px;">
                    <el-input-number v-model="item.number" @change="handleChange(item)" :min="item.limits" size="small"></el-input-number>
                    <div class="list_sureinput_b">
                      {{ item.units }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="cght_cnxhtiwtjsp" v-if="emptyShow && list.length==0">
                <div>
                  <em class="myemptydata">暂无数据</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
  </div>
  <Footer/>
  </div>
</template>
<script>
import cate from '@/api/createGroy'
import api from '@/api/goods'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import CountTo from 'vue-count-to'
import { mapGetters } from 'vuex'

export default {
  name: 'Goods',
  mixins: [vuelist],
  inject: ['reload'], // 注入依赖
  components: { Pagination, Navigationzj, Header, Footer, CountTo },
  data () {
    return {
      api,
      cid: this.$route.query.cid || this.$route.query.parent_id || this.$route.query.grand_id,
      cateGroyMsg: [],
      level1name: '',
      level2name: '',
      level3name: '',
      level4name: '',
      isShow: '',
      qyloading: false,
      atterloading: false,
      listQuery: {
        category_id: this.$route.query.cid,
        category_parent_id: this.$route.query.parent_id,
        category_grand_id: this.$route.query.grand_id,
        cgid: this.$route.query.cgid,
        myprice: false
      },
      listMode: 'card',
      myprice: false,
      num: '',
      Attribute: [],
      brandList: [],
      selectName: [],
      group_list: [],
      group_id: '',
      brandType: false,
      selectBrand: [],
      priceType: false,
      emptyShow: false,
      u: 4,
      AttrOpen: false,
      AttrStyle: {
        marginTop: '10px',
        borderBottom: 'none'
      },
      fourtitle: this.$route.query.title
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    this.getCateGroyMsg()
    // this.LoadData()
  },
  methods: {
    screen () {
      this.myprice = !this.myprice
      this.listQuery.page = 1
      this.listQuery.myprice = this.myprice
      this.LoadData()
    },
    afterLoadData (list) {
      list.forEach(res => {
        if (res.specParamList) { res.specParamList = JSON.parse(res.specParamList) }
      })
      this.emptyShow = true
      return list
    },
    handleClose (index) {
      console.info(this.Attribute)
      this.Attribute.forEach((res, i) => {
        if (res.id === this.selectName[index].param_id) {
          this.$set(this.Attribute[i], 'isSelect', false)
        }
      })
      if (this.selectName[index].code) {
        this.brandType = false
        this.selectBrand = []
      }
      this.selectName.splice(index, 1)
      this.attrFiltrate()
    },
    getCateGroyMsg () {
      var towNameID = null
      var oneNameID = null
      cate.getCateGroyMsg({ 'cid': this.cid }).then(res => {
        this.cateGroyMsg = res.items
        if (this.cateGroyMsg.threeChildren) {
          this.cateGroyMsg.threeChildren.map(res => {
            if (res.id === parseInt(this.cid)) {
              this.level3name = res.title
              towNameID = res.parent_id
            }
          })
        }
        if (this.cateGroyMsg.group_list && this.cateGroyMsg.group_list.length > 0) {
          this.level4name = this.cateGroyMsg.group_list[0].name
        }
        this.cateGroyMsg.children.map(res => {
          if (res.id === (towNameID || parseInt(this.cid))) {
            this.level2name = res.title
            oneNameID = res.parent_id
          }
        })
        this.cateGroyMsg.message.map(res => {
          if (res.id === (oneNameID || parseInt(this.cid))) {
            this.level1name = res.title
          }
        })
        // 如果不是第三级分类则不查询属性
        if (this.$route.query.cid && res.items.group_list.length > 0) {
          this.getAttribute(res.items.group_list[0].id)
          // this.listQuery.group_id = res.items.group_list[0].id
        }
        this.LoadData()
      })
    },
    isOrNo (string) {
      this.isShow = string
    },
    leave () {
      this.isShow = ''
    },
    handleChange (item) {},
    checkBrand (index) {
      this.brandType = true
      this.selectBrand = this.brandList[index] // 此处赋值只为点击品牌传值，减少后台处理
      this.selectName.push(this.brandList[index])
      this.attrFiltrate()
    },
    getAttribute (groupId) {
      var byValue = {}
      if (groupId) {
        byValue = {
          cid: this.cid,
          groupId: groupId,
          cgid: this.listQuery.cgid
        }
      } else {
        byValue = {
          cid: this.cid,
          cgid: this.listQuery.cgid
        }
      }
      this.atterloading = true
      cate.getAttribute(byValue).then(res => {
        let list = res.items
        let brandList = res.brandList
        list.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        this.brandList = brandList
        this.atterloading = false
        // 判断属性修改样式
        if (this.Attribute.length > 4) {
          this.AttrStyle = {
            marginTop: '10px',
            borderBottom: 'none'
          }
        } else {
          this.AttrStyle = {
            marginTop: '10px'
          }
        }
      })
    },
    checkAttribute (i, index) {
      this.$set(this.Attribute[index], 'isSelect', true)
      this.selectName.push(this.Attribute[index]['option_values'][i])
      this.attrFiltrate()
    },
    attrFiltrate () {
      var newSelectName = Object.assign([], this.selectName)
      newSelectName.forEach((res, index) => {
        if (res.code) {
          newSelectName.splice(index, 1)
        }
      })
      this.atterloading = true
      api.attrFiltrate({attrrButeList: JSON.stringify(newSelectName), category_id: this.cid, brand: JSON.stringify(this.selectBrand), groupId: this.listQuery.group_id, cgid: this.listQuery.cgid}).then(response => {
        let list = response.items
        let brandList = response.brand_list
        list.forEach(ele => {
          ele.showMore = false; ele.open = false; ele.isSelect = false
          this.selectName.forEach(res => {
            if (ele.id === res.param_id) {
              ele.isSelect = true
            }
          })
        })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        // 判断属性修改样式
        if (this.Attribute.length > 4) {
          this.AttrStyle = {
            marginTop: '10px',
            borderBottom: 'none'
          }
        } else {
          this.AttrStyle = {
            marginTop: '10px'
          }
        }
        this.brandList = brandList
        this.atterloading = false
        this.listQuery.page = 1
        this.listQuery.goods_list_id = response.goods_id
        this.LoadData()
      })
    },
    changeOpen (index) {
      this.$set(this.Attribute[index], 'open', !this.Attribute[index].open)
    },
    getHeight (name, index) {
      this.$nextTick(() => {
        if (this.$refs[name][0]['offsetHeight'] > 34) {
          this.Attribute[index].showMore = true
        }
      })
    },
    // 收藏
    collect (item) {
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.delOrAddCollect({'member_id': this.current_user.id, 'goods_id': item.id}).then(res => {
        item.isCollect = item.isCollect === 1 ? 0 : 1
      })
    },
    addCart (item) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      api.addCart({
        'id': item.id,
        'leaveMessage': item.leaveMessage
      }).then(response => {
        this.$notify({
          title: '加入购物车',
          message: '添加成功',
          type: 'success'
        })
      })
    },
    checkParam (item) {
      this.level4name = item.name
      this.getAttribute(item.id)
      this.listQuery.group_id = item.id
      this.listQuery.page = 1
      // this.fourCate.forEach(res => { res.typeLb = false })
      // item.typeLb = true
      this.selectName = []
      this.listQuery.goods_list_id = ''
      this.LoadData()
    },
    batchAddCart () {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      var subCartList = []
      this.list.map((res, index) => {
        if (res.number) {
          var cartList = {
            goods_id: res.id,
            number: res.number,
            leaveMessage: res.leaveMessage
          }
          // if (this.subCartList.findIndex((item) => { return item.goods_id === res.id }) === -1) {
          subCartList.push(cartList)
          // }
        // } else {
        //   this.subCartList.splice(index, 1)
        }
      })
      if (subCartList.length > 0) {
        api.batchAddCart(subCartList).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        })
      }
    },
    changeAttrOpen () {
      if (this.AttrOpen) {
        this.u = 4
        this.AttrOpen = false
      } else {
        this.u = this.Attribute.length
        this.AttrOpen = true
      }
    }
  }
}
</script>
<style scoped>
  .agreement{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 12;
    width: 60px;
  }
  .agreement_list{
    background-image:url('../../assets/images/xy22.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: 70px 70px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .this_page_title{
    padding: 0 7px 0 7px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .hxq_ppsp_ul_jg {
    padding: 0 7px 0 7px;
  }
  .hxq_ppsp_ul_join{
    padding: 0 7px 0 7px;
  }
  .this_page_css {
    border-radius:5px ;
    margin: 15px 15px 0 0;
    padding: 10px 3px 10px 3px;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
    border:1px solid #eaeaea;
  }
  .this_page_css:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .this_page_li {
    margin: 15px 0;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
  }
  .this_page_li:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .fllbsmall_con_bottom_1l img {
    border: none;
  }
  .fllbsmall_con_bottom li{
    border: none;
    padding: 5px 0;
  }
  .myborder{
    height: 34px;
    line-height: 34px;
    border-bottom: none !important;
  }
  .selectTrue{
    float: left;
    padding: 6px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    margin-left: 18px;
    margin-bottom:12px;
  }
  .delSelect{
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    color:#fff;
    line-height: 20px;
    text-align: center;
    font-weight: bold;
    background: #4b8df9;
  }
  .hxq_fllb_ysz_yj{
    transition: all .5s ease;
    overflow: hidden;
    box-sizing: border-box;
  }
  .hxq_fllb_ysz .hxq_fllb_ysz_yj{
    padding: 0;
    border: none;
  }
  .el-radio{
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .showMoreAttr {
    background: #fff none repeat scroll 0 0;
    border-top: 1px solid #ddd;
    color: #999;
    cursor: pointer;
    font-size: 12px;
    height: 30px;
    line-height: 20px;
    position: relative;
    text-align: center;
    z-index: 1;
  }
  .showMoreAttr:hover{
    border-top: 1px solid #333;
    color: #333;
  }
  .showMoreAttr:hover .showmore-text{
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }
  .showmore-text {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    display: block;
    height: 30px;
    line-height: 29px;
    margin-left: 450px;
    margin-top: -1px;
    position: absolute;
    width: 350px;
    z-index: 1;
  }
  .showmore-text:hover{
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }
  .showmore-text i.up-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    background: url(../../assets/images/xjt.png) center 10% no-repeat;
  }
  .showmore-text i {
    width: 20px;
    height: 20px;
    background: url(../../assets/images/xjt.png) center 85% no-repeat;
    cursor: pointer;
    display: inline-block;
  }
.cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
.cght_cnxhtiwtjsp div{ width:144px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
.myemptydata {color:#959595}
</style>



// WEBPACK FOOTER //
// src/view/goods/goods.vue